import config from '../../config';
import Auth from '@/utils/auth';

const isProduction = process.env.NODE_ENV === 'production';
const apiUrl = isProduction ? config.apiProd : config.apiDev;

// const getHeaders = () => ({
//   Authorization: `Bearer ${window.localStorage.getItem("user")}`,
//   "Content-Type": "application/json"
// });

const queryParams = params =>
  Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");

const API_BASE = apiUrl;

const handleResponse = response => {
  if ([401, 403].includes(response.statusCode)) {
    localStorage.removeItem("token");
    window.location = "/";
  }
  if ([301,405].includes(response.statusCode)) {
    throw new Error("Network response was not ok.");
  }
  if (response.ok) {
    return response.json();
  }
  throw new Error("Network response was not ok.");
};

export const fetchOrders = (payload,count = 0) =>
  fetch(`${API_BASE}/orders?${queryParams(payload)}&all`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(q){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

export const fetchStatuses = (count = 0) =>
  fetch(`${API_BASE}/statuses`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(q){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

export const fetchRegInfo = (id,count = 0) => fetch(
  `${API_BASE}/order?btag=${id}`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  },
).then(handleResponse).catch(function(){
  if (count < 10){
    count++
    fetchOrders(payload,count)
  }
});

export const fetchRefusals = (count = 0) =>
  fetch(`${API_BASE}/refusal`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

export const sendOrderData = ({ id, payload },count = 0) => fetch(
  `${API_BASE}/order?btag=${id}`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    method: 'PUT',
    body: JSON.stringify({
      client: payload
    }),
    timeout: 120000
  },
).then(handleResponse).catch(function(){
  if (count < 10){
    count++
    fetchOrders(payload,count)
  }
});

export const sendRegClientInfo = ({ id, payload },count = 0) =>
  fetch(`${API_BASE}/order?btag=${id}`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    method: "PUT",
    body: JSON.stringify({
      client: payload
    }),
    timeout: 120000
  }).then(handleResponse).catch(function(){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

// export const login = payload =>
//   fetch(`${API_BASE}/login`, {
//     headers: {
//       'Authorization': Auth.getAuthHeader(),
//     },
//     method: "POST",
//     body: JSON.stringify(payload)
//   }).then(handleResponse);

export const fetchOrder = (id,count = 0) =>
  fetch(`${API_BASE}/order?btag=${id}`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

export const fetchDayByDayStatistic = (data,count = 0) =>
  fetch(`${API_BASE}/getDayByDayStatistic?page=${data.page}&limit=${data.limit}`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });

export const fetchOrdersStatistic = (count = 0) =>
  fetch(`${API_BASE}/ordersStatistic`, {
    headers: {
      'Authorization': Auth.getAuthHeader(),
      "Content-Type": "application/json"
    },
    timeout: 120000
  }).then(handleResponse).catch(function(){
    if (count < 10){
      count++
      fetchOrders(payload,count)
    }
  });
